// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

const SETTER_HIDDEN_RESOURCES = new Set([
  "operations",
  "installers",
  "email",
  "import",
  "team",
]);

export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  role: string,
  params: CanAccessParams<RecordType>,
) => {
  if (role === "admin") {
    return true;
  }

  // Non admins can't access the sales resource
  if (params.resource === "sales") {
    return false;
  }

  // Money (revenue, costs and margins) is for the partners only
  if (params.resource === "money") {
    return false;
  }

  // Web stats (visits, heat maps, chatbot conversations) are for admins
  if (params.resource === "web") {
    return false;
  }

  // Setters sell: Inicio, Mi jornada, Clientes, Contactos and WhatsApp.
  // Shipping and installations, email marketing, installers and bulk
  // imports stay with the admins.
  if (SETTER_HIDDEN_RESOURCES.has(params.resource)) {
    return false;
  }

  // Non admins can't access the configuration resource
  if (params.resource === "configuration") {
    return false;
  }

  return true;
};
